<template>
  <div class="mt-2">
    <v-card outlined>
      <v-card-text v-if="documents.length > 0" class="pb-0 pt-1">
        <v-row v-for="document in documents"
               :key="document.id"
               class="d-flex align-center mt-1 my-2 pl-2">
          <v-text-field
              v-if="editNameOnDocumentId === document.id"
              outlined
              dense
              hide-details="auto"
              v-model="document.name"
              class="flex-grow-1 mr-2"
              @keydown.enter="toggleNameEdit(document)"
              :rules="[ buildRequiredValidator(), buildMaxLengthValidator(maxNameLength),]"/>
          <span v-if="editNameOnDocumentId !== document.id"
                class="flex-grow-1 documentName"
                @click="toggleNameEdit(document)">
            {{ document.name }}
          </span>
          <v-btn icon
                 @click="toggleNameEdit(document)"
                 dense>
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn @click="remove(document)"
                 icon
                 :title="$t('actions.delete')"
                 dense>
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="add" small>
          <v-icon>mdi-circle-plus</v-icon>
          {{ $t('actions.add') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <document-select-dialog ref="documentSelectDialog" @uploaded="added"/>
  </div>
</template>

<script>
import DocumentSelectDialog from '@/components/inputs/DocumentSelectDialog';
import {
  buildRequiredValidator,
  buildMaxLengthValidator,
} from '@/utils/ValidatorBuilders';

const maxNameLength = 255;

export default {
  name: 'DocumentsSelect',
  components: { DocumentSelectDialog },
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  data: () => ({
    editNameOnDocumentId: null,
    maxNameLength,
  }),

  methods: {
    buildRequiredValidator,
    buildMaxLengthValidator,

    add() {
      this.$refs.documentSelectDialog.show();
    },
    remove(document) {
      this.documents = this.documents.filter((doc) => doc.id !== document.id);
    },
    added(document) {
      this.documents.push(document);
    },

    toggleNameEdit(document) {
      if (this.editNameOnDocumentId === document.id) {
        if (
            document.name &&
            document.name !== '' &&
            document.name.length <= this.maxNameLength
        ) {
          this.editNameOnDocumentId = null;
        }
      } else {
        this.editNameOnDocumentId = document.id;
      }
    },
  },

  computed: {
    documents: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },

    headers() {
      return [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'action',
          width: '4em',
        },
      ];
    },
  },
};
</script>

<style>
.documentName {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 400;
}
</style>
